import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { getCookie } from "@/services/Auth/loginService";
import { getUserRole } from "@/services/Auth/loginService";

const PublicRoute = ({ restricted }) => {
  const [redirect, setRedirect] = useState(null);
  const navigate = useNavigate();
  const token = getCookie("token");
  const role = getUserRole();

  useEffect(() => {
    if (token && restricted) {
      Swal.fire({
        title: 'Redirigiendo...',
        text: 'Por favor, espere...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Muestra el loader
        }
      });

      // Redirigir según el rol después de un pequeño retraso
      setTimeout(() => {
        let path = "/";
        switch (role?.toLowerCase()) {
          case "client":
            path = "/dashboard/client";
            break;
          case "lawyer":
          case "abogado":
            path = "/dashboard/lawyer";
            break;
          case "admin":
            path = "/dashboard/admin";
            break;
          default:
            path = "/";
        }
        Swal.close();
        setRedirect(path); // Actualiza el estado de redirección
      }, 1500); // Ajusta el tiempo de espera según sea necesario
    }
  }, [token, restricted, role]);

  // Si el estado de redirección se establece, hacer la redirección
  if (redirect) {
    navigate(redirect); // Realiza la redirección usando el hook de navigate
    return null; // No renderiza nada mientras redirige
  }

  return <Outlet />;
};

export default PublicRoute;
